import { render, staticRenderFns } from "./IconTextItalic.vue?vue&type=template&id=4c075b03&"
import script from "./IconTextItalic.vue?vue&type=script&lang=js&"
export * from "./IconTextItalic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c075b03')) {
      api.createRecord('4c075b03', component.options)
    } else {
      api.reload('4c075b03', component.options)
    }
    module.hot.accept("./IconTextItalic.vue?vue&type=template&id=4c075b03&", function () {
      api.rerender('4c075b03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTextItalic.vue"
export default component.exports